import Vue from 'vue';

/**
 * B2B-320 — event bus global e minúsculo para notificações do tipo
 * `data.action = 'action'`: quem dispara não precisa conhecer quem reage.
 * TheNotifications.vue emite `data.action_name`; quem quiser reagir (ex:
 * Layout.vue abrindo um modal) escuta pelo mesmo nome em mounted()/beforeDestroy().
 *
 * Não é específico de achievements — é infraestrutura reaproveitável para
 * qualquer notificação futura que precise abrir algo na SPA em vez de navegar.
 */
export default new Vue();
